import React from "react";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useDispatch, useSelector } from "react-redux";
import { getListRun, resetRunState } from "../../reducers/runReducer";
import { getAllVehicle } from "../../reducers/vehicleReducer";
import { createNewReport } from "../../reducers/reportReducer";
import { useNavigate } from 'react-router-dom';
import useRudderStackAnalytics from "../../config/useRudderAnalytics";
export default function CreateReport(){
    const useRudderAnalytics=useRudderStackAnalytics();
    const driverName=useSelector(state=>state.driver.entities.currDriver?.driverName);
    const driverId=useSelector(state=>state.driver.entities.currDriver?.driverId);
    const run=useSelector(state=>state.run.entities.runList);
    const site=useSelector(state=>state.driver.entities.currDriver?.site);
    const vehicle=useSelector(state=>state.vehicle.entities.vehicleList);
    const reportNavigation=useSelector(state=>state.report.entities.reportNavigation);
    const reportError=useSelector(state=>state.report.entities.error);
    const [isSubmit, setSubmit]=React.useState(false);
    const navigate=useNavigate();
    const [formData, setFormData]=React.useState({
        date:dayjs(),
        site: "",
        driver: "",
        driverId:"",
        deliveryDate:dayjs(),
        deliveryDay:"",
        run:"",
        departureTime:dayjs(),
        vehicle:"",
        temperatureDeparture:"",
        temperatureAt2H:"",
        temperatureAt4H:"",
        temperatureAt6H:"",
        comment:"",
        temperatureAtEndShift:"",
        version:"v1",
        company:"thefruitbox"
    });
    const runElements=run && run.length>0?run.map((e,i)=><MenuItem sx={{fontSize:"0.8rem", whiteSpace:"normal"}} value={e.runName}>{e.runName}</MenuItem>):<MenuItem value={""}>No Run Available</MenuItem>
    const vehicleElements=vehicle && vehicle.length>0?vehicle.map((e,i)=><MenuItem sx={{fontSize:"0.8rem", whiteSpace:"normal"}}  value={e.license}>{e.license}</MenuItem>):<MenuItem value={""}>No Vehicle Available</MenuItem>
    const dispatch=useDispatch();
    React.useEffect(()=>{
        if(reportNavigation && reportNavigation.driverId && reportNavigation.date){
            navigate(`/${reportNavigation.driverId}/haccp/report/${reportNavigation.date.toString()}`);
        }
    },[reportNavigation, navigate])
    React.useEffect(()=>{
        if(driverName){
            setFormData(prev=>{
                    return {
                        ...prev,
                        driver:driverName,
                        driverId:driverId,
                        site:site
                    }
            })
        }
        //clear run cache
        dispatch(resetRunState())
    },[driverName, dispatch, driverId, site])
    const handleSubmit=async (e)=>{
        e.preventDefault();
         const deliveryDate=dayjs(formData.deliveryDate).format("YYYY-MM-DD").toString();
        if(dayjs(deliveryDate).isBefore(dayjs((dayjs(formData.date).toISOString().split("T")[0])))){
            window.alert('Delivery Date and Time should not be in the past')    
        }
        else{
            await dispatch(createNewReport({data:formData, driverId}))
            setSubmit(true);
        }
        
    }
    React.useEffect(()=>{
        if(isSubmit && window.navigator.onLine && !reportError && useRudderAnalytics) {
            useRudderAnalytics.track("Create Vehicle Temp", {...formData,date:dayjs(formData.date).format("YYY-MM-DD").toString(), deliveryDate: dayjs(formData.deliveryDate).format("YYYY-MM-DD").toString(), departureTime:dayjs(formData.departureTime).format("HH:mm:ss").toString()})
            window.alert('Vehicle Temperature Report Updated Successfully');
        }
        else if(isSubmit && (!window.navigator.onLine || reportError) && useRudderAnalytics) {
            useRudderAnalytics.track("Create Vehicle Temp Error", {...formData, deliveryDate: dayjs(formData.deliveryDate).format("YYYY-MM-DD").toString(),date:dayjs(formData.date).format("YYY-MM-DD").toString(), departureTime:dayjs(formData.departureTime).format("HH:mm:ss").toString()})
            window.alert('Something went wrong, please check your connection and try again.')
        }
        setSubmit(false)
    },[reportError, isSubmit, formData, useRudderAnalytics])
    const handleChange=async (e)=>{
        if (e.$d){
            setFormData(prev=>{
                return {
                    ...prev,
                    deliveryDate:dayjs(e.$d)
                }
            })
        }
        else{
            const {name, value}=e.target
            setFormData(prev=>{
                return {
                    ...prev,
                    [name]: value                    
                }
            })
            
        }
    }
    //fetch all run depends on Delivery Day and Site
    React.useEffect(()=>{
        if(formData.deliveryDay && formData.site && driverId){
            dispatch(getListRun({site:formData.site, day:formData.deliveryDay, driverId}));
        }
    },[formData.deliveryDay, formData.site, dispatch, driverId])
    React.useEffect(()=>{
        if(formData.site && driverId){
            dispatch(getAllVehicle({site:formData.site, driverId}))
        }
    },[formData.site, driverId, dispatch]);
    React.useEffect(()=>{
        if(run&&!run.find(e=>e.runName===formData.run)){
            setFormData(prev=>{
                return{
                    ...prev,
                    run:""
                }
            })
        }
    },[run, formData.run])
    React.useEffect(()=>{
        if(useRudderAnalytics && driverId){
            useRudderAnalytics.page("Create Vehicle Temp")
        }
    },[useRudderAnalytics, driverId])
    const element=driverId?            
    <form onSubmit={handleSubmit} className="reportForm">
            <div className="reportField">
                <h3>Driver and Vehicle Registration</h3>
            </div>
            <div className="reportFieldBackground">
            <FormControl className="reportField">
                <TextField value={formData.site} name="site" onChange={handleChange} disabled label="Site:" variant="outlined" />
            </FormControl>
            <FormControl className="reportField">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker', 'DatePicker']}>
                    <DatePicker
                        name="deliveryDate"
                        label="Date:"
                        value={formData.deliveryDate}
                        format="DD/MM/YYYY"
                        onChange={handleChange}
                        disablePast
                    />
                </DemoContainer>
            </LocalizationProvider>
            </FormControl>
            <FormControl className="reportField">
                <TextField value={formData.driver} name="driver" onChange={handleChange} disabled label="Driver:" variant="outlined" />
            </FormControl>
            
            <FormControl className="reportField">
            <InputLabel id="deliveryDay">Delivery Day:</InputLabel>
                <Select
                    labelId="deliveryDay"
                    name="deliveryDay"
                    value={formData.deliveryDay}
                    label="deliveryDay"
                    onChange={handleChange}
                    required
                >
                    <MenuItem value={"monday"}>Monday</MenuItem>
                    <MenuItem value={"tuesday"}>Tuesday</MenuItem>
                    <MenuItem value={"wednesday"}>Wednesday</MenuItem>
                    <MenuItem value={"thursday"}>Thursday</MenuItem>
                    <MenuItem value={"friday"}>Friday</MenuItem>
                    <MenuItem value={"saturday"}>Saturday</MenuItem>
                    <MenuItem value={"sunday"}>Sunday</MenuItem>
                </Select>
            </FormControl>
            <FormControl className="reportField">
                <InputLabel id="run">Delivery Run:</InputLabel>
                <Select
                    labelId="run"
                    name="run"
                    value={formData.run}
                    label="Delivery Run"
                    onChange={handleChange}
                    required
                >
                    {runElements}
                </Select>
            </FormControl>
            {/* <FormControl className="reportField">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['TimePicker']}>
                        <TimePicker value={formData.departureTime} onChange={handleTimeChange} label="Departure Time" />
                    </DemoContainer>
                    </LocalizationProvider>
            </FormControl> */}
            <FormControl className="reportField">
                <InputLabel id="vehicle">Delivery Vehicle:</InputLabel>
                <Select
                    labelId="vehicle"
                    name="vehicle"
                    value={formData.vehicle}
                    label="Delivery Vehicle"
                    onChange={handleChange}
                    required
                >
                    {vehicleElements}
                </Select>
            </FormControl>
            </div>
            <div className="reportField">
                <h3>CRITICAL LIMITS:</h3>
            </div>
            <FormControl className="reportField">
                <p>Vehicles are to be temperature checked at the time of departure and then every 2 hours.</p>
                <p>Vehicle temperatures must be less than or equal to 5 degrees C.</p>
            </FormControl>
            <FormControl className="reportField">
                <p>&gt;5 Degrees C?</p>
                <p>Please notify your State Manager if temperatures are &gt;5 degrees C.</p>
            </FormControl>
            <div className="reportField">
                <h3>Vehicles Temperatures:</h3>
            </div>
            <div className="reportFieldBackground">
            <FormControl className="reportField">
                <TextField value={formData.temperatureDeparture} name="temperatureDeparture" type="number" required onChange={handleChange} label="Vehicle Temperature at Departure:" variant="outlined" />
            </FormControl>
            <FormControl className="reportField">
                <TextField value={formData.temperatureAt2H} name="temperatureAt2H" type="number" onChange={handleChange} label="Vehicle Temperature at 2H:" variant="outlined" />
            </FormControl>
            <FormControl className="reportField">
                <TextField value={formData.temperatureAt4H} name="temperatureAt4H" type="number" onChange={handleChange} label="Vehicle Temperature at 4H:" variant="outlined" />
            </FormControl>
            <FormControl className="reportField">
                <TextField value={formData.temperatureAt6H} name="temperatureAt6H" type="number" onChange={handleChange} label="Vehicle Temperature at 6H:" variant="outlined" />
            </FormControl>
            <FormControl className="reportField">
                <TextField value={formData.comment} name="comment" type="text" onChange={handleChange} label="Comments:" variant="outlined" />
            </FormControl>
            <FormControl className="reportField">
                <TextField value={formData.temperatureAtEndShift} name="temperatureAtEndShift" type="number" onChange={handleChange} label="Vehicle Temperature at End of Shift:" variant="outlined" />
            </FormControl>
            
            </div>
            <Button type="submit" variant="contained" style={{marginBottom:"10px", marginTop:"10px"}}>Create</Button>
    </form>:<></>
    return (
        <div style={{display:"flex", flexDirection:"column", alignItems:"center"}}>
            {element}
        </div>
    )
}